import React from 'react';
import LimitTableFilter from '../../../components/limit/LimitTableFilter';
import styled from 'styled-components';

function SaleStatisticsLimit({ isRegion }: { isRegion?: boolean }) {
  return (
    <LimitTableFilter title="매각통계는" nohead isRegion={isRegion}>
      <MonthTabBox>
        <MonthTab active>3개월</MonthTab>
        <MonthTab>6개월</MonthTab>
        <MonthTab>12개월</MonthTab>
      </MonthTabBox>
    </LimitTableFilter>
  );
}

export default SaleStatisticsLimit;

interface MonthTabProps {
  active?: boolean;
}

const MonthTab = styled.div<MonthTabProps>`
  display: flex;
  flex-direction: row;
  padding: 6px 16px;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 9999px;
  color: ${({ active }) => (active ? '#008AFF' : '#989BA2')};
  background-color: ${({ active }) =>
    active ? '#fff' : 'rgba(112, 115, 124, 0.08)'};
  border: ${({ active }) => (active ? '1px solid #008AFF' : 'none')};
`;

const MonthTabBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
